import { useState } from "react"

import { Button, Popover, PopoverBody } from "reactstrap"

import { useScenario } from "../contexts/ScenarioContext"

export default function RevealTableRow({label, category, value}) {
    const {logPatientStatusRequest } = useScenario()
    const [popoverOpen, setPopoverOpen] = useState(false);   

    const hideOverlay = () => {
        setTimeout(function(){setPopoverOpen(false)}, 500)
    } 

    const clickHandler = (value)  => {
        setPopoverOpen(true)
        logPatientStatusRequest(category, label, value)
        hideOverlay()
    }

    return (
        <tr>
            <th>{label} </th>
            <td>{value}</td>
            <td>
                <div>
                <Button
                    id="patientBtn"
                    color="success"
                    size="sm"
                    className="request-btn"
                    onClick={() => clickHandler(value)}
                >
                    Requested
                </Button>
                <Popover
                    size="sm"
                    placement="left" 
                    isOpen={popoverOpen}
                    target='patientBtn'
                    trigger="focus">
                        <PopoverBody>Recorded</PopoverBody>
                    </Popover>
                </div>
            </td>
        </tr>
    )

}